const ChevronLeft = () => {
  return (
    <svg width="22" height="41" viewBox="0 0 22 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0607 16.1319L11 15.0713L6 20.0713L11 25.0713L12.0607 24.0106L8.12132 20.0713L12.0607 16.1319Z"
        fill="#4F4F4F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0607 16.1319L17 15.0713L12 20.0713L17 25.0713L18.0607 24.0106L14.1213 20.0713L18.0607 16.1319Z"
        fill="#4F4F4F"
      />
    </svg>
  );
};

export default ChevronLeft;
